// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66bb6ce5","239":"916dee1d","553":"fc76cc95"}[chunkId] + ".chunk.js";
};